import React from 'react';

import { EncounterLineItem } from './encounterLineItem.jsx';

function EncounterLineItemList({
  encounterId,
  lineItems,
  openAcceptRejectDialog
}) {
  return (
    <>
      {
        lineItems.length === 0
          ? (<Typography sx={{ textAlign: 'center' }}>No Line Items</Typography>)
          : lineItems.map(x => (
              <EncounterLineItem
                key={x.encounterLineItemId}
                encounterId={encounterId}
                openAcceptRejectDialog={openAcceptRejectDialog}
                {...x}
              />
            ))
      }
    </>
  );
}

export { EncounterLineItemList };
